{
  "title": "Stock levels",
  "subtitle": "How much you have right now, in every location, and what it is worth.",
  "subtitleSite": "How much you have right now in this site, place by place.",
  "export": "Export to Excel",
  "totalValue": "Total stock value · all locations",
  "tabs": {
    "all": "All products",
    "low": "Low",
    "out": "Out of stock",
    "negative": "Negative",
    "overstock": "Overstock"
  },
  "matrix": "Product × location",
  "mode": "Show",
  "quantities": "Quantities",
  "values": "Values (TND)",
  "search": "Product, SKU or barcode",
  "category": "Category",
  "allCategories": "All categories",
  "product": "Product",
  "directly": "{{name}} (directly)",
  "total": "Total",
  "value": "Value (TND)",
  "valueOf": "Value {{value}} TND",
  "empty": "No product matches",
  "legend": {
    "title": "Colours:",
    "negative": "Negative",
    "low": "At or below minimum",
    "out": "Out of stock",
    "overstock": "Above maximum",
    "never": "Never stocked here"
  },
  "showing": "Showing {{shown}} of {{total}} products",
  "byCategory": "Valuation by category",
  "byCategoryHint": "Quantity × weighted average cost · total {{total}} TND",
  "noCategory": "No category",
  "productCount_one": "{{count}} product",
  "productCount_other": "{{count}} products",
  "reserved": "Reserved",
  "available": "Available",
  "reservedOf": "{{reserved}} reserved for orders · {{available}} available",
  "limits": {
    "title": "Stock limits",
    "subtitle": "The minimum and maximum of each product and variant at one location. At or below the minimum you get a “Low stock” alert, above the maximum an “Overstock” alert.",
    "location": "Location",
    "tabsLabel": "Products shown",
    "tabs": {
      "all": "All products",
      "limited": "With limits"
    },
    "search": "Search a product, SKU or barcode",
    "allCategories": "All categories",
    "allBrands": "All brands",
    "clear": "Clear filters",
    "product": "Product",
    "here": "Stock here",
    "hereHint": "A site counts its sub-locations.",
    "min": "Min",
    "max": "Max",
    "state": "State",
    "changes_one": "{{count}} change not saved",
    "changes_other": "{{count}} changes not saved",
    "locked": "Save or undo the changes before changing the location, the filters or the page.",
    "undo": "Undo",
    "save": "Save the limits",
    "saved_one": "Limits saved for {{count}} product.",
    "saved_other": "Limits saved for {{count}} products.",
    "unchanged": "Nothing changed.",
    "fixErrors": "Some values need checking.",
    "noPlace": "You have no location to set limits at.",
    "noMatch": {
      "title": "No product found",
      "text": "Try another search or filter."
    },
    "showing": "{{first}}–{{last}} of {{total}} products"
  }
}
